var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluteLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 12,
    viewBox: "0 0 41 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8546H2.54442V7.00992H8.91441V4.84464H2.54442V2.16504H8.91441V0H0V11.8546Z",
    fill: "#171715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0208 0H10.6594V11.8546H13.0208V0Z",
    fill: "#171715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6148 7.99745C21.6148 9.07097 20.9742 9.90785 19.9857 9.90785H18.8142C17.8257 9.90785 17.1851 9.07073 17.1851 7.99745V2.68457H14.824V8.48873C14.824 10.5083 16.3251 12.0002 18.0824 12.0002H20.7183C22.4756 12.0002 23.9767 10.5083 23.9767 8.48873V2.68457H21.6155V7.99745H21.6148Z",
    fill: "#171715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1402 0H25.7791V2.6844V4.64952V9.14352C25.7791 11.0177 26.7859 11.8546 28.5248 11.8546H30.9778V9.88944H29.1838C28.5615 9.88944 28.1405 9.6528 28.1405 8.88864V4.64928H30.9778V2.68416H28.1405V0H28.1402Z",
    fill: "#171715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 6.97809C41.0001 4.50369 39.2428 2.53857 36.863 2.53857H36.0942C33.9893 2.53857 31.7194 4.26705 31.7194 7.25097C31.7194 10.0165 33.6049 11.9996 36.1309 11.9996H36.863C38.968 11.9996 40.7072 10.6715 40.9083 8.76105H38.6568C38.5285 9.47073 37.7965 10.0527 36.8995 10.0527H36.149C35.1057 10.0527 34.2452 9.25209 34.0808 7.77849H40.9634C40.9634 7.68753 41.0001 7.39641 41.0001 6.97785V6.97809ZM34.1723 6.12321C34.4835 4.97697 35.2706 4.35825 36.1309 4.35825H36.863C37.8148 4.35825 38.6203 5.12241 38.6751 6.12321H34.172H34.1723Z",
    fill: "#171715"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluteLogo);
export default __webpack_public_path__ + "static/media/flute_logo.67071f683c93507a51a4da44307da06d.svg";
export { ForwardRef as ReactComponent };